import ContentTypography from './ContentTypography';

interface ContentParagraphProps {
    data: {
        text: string;
    };
    id: string;
    className?: string;
}

export default function ContentParagraph(props: ContentParagraphProps) {
    return <ContentTypography key={props.id} text={props.data.text} variant='body1' className={props.className} />;
}
